import React from "react";
import { Table } from "reactstrap";

import { ETAPA_STATUS_UI, ETAPA_UI, EXECUCAO_UI, etapasDoPreset, execucaoMaisRecente, fmtDataHora, fmtDataISO, fmtNumero, progressoExecucao } from "../regras";

// Aba Etapas (H8 PO1-2848): lista das etapas do preset com status, prazo e a
// última execução (etapas assíncronas), vinda de GET /execucoes.

const TIPO = { tela: "Tela", assincrona: "Assíncrona", prazo: "Prazo", automatica: "Automática" };

export default function AbaEtapas({ bid, execucoes }) {
  const etapas = etapasDoPreset(bid.preset);
  const porEtapa = {};
  (bid.etapas || []).forEach((e) => {
    porEtapa[e.etapa] = e;
  });

  return (
    <Table className="bf-table" size="sm" responsive>
      <thead className="text-primary">
        <tr>
          <th>#</th>
          <th>Etapa</th>
          <th>Tipo</th>
          <th>Status</th>
          <th>Prazo</th>
          <th>Última execução</th>
          <th className="is-number">Progresso</th>
        </tr>
      </thead>
      <tbody>
        {etapas.map((etapa, i) => {
          const ui = ETAPA_UI[etapa];
          const reg = porEtapa[etapa] || {};
          const st = ETAPA_STATUS_UI[reg.status] || ETAPA_STATUS_UI.PENDENTE;
          const exec = ui.tipo === "assincrona" ? execucaoMaisRecente(execucoes, etapa) : null;
          const eu = exec ? EXECUCAO_UI[exec.situacao] : null;
          return (
            <tr key={etapa}>
              <td>{i + 1}</td>
              <td>
                <strong>{ui.label}</strong>
                <div className="lf-muted">{ui.descricao}</div>
              </td>
              <td>{TIPO[ui.tipo]}</td>
              <td>
                <span className={`lf-badge lf-badge-${st.tone}`}>{st.label}</span>
              </td>
              <td>{reg.prazo ? fmtDataISO(reg.prazo) : "—"}</td>
              <td>
                {exec ? (
                  <>
                    <span className={`lf-badge lf-badge-${eu ? eu.tone : "neutral"}`}>{eu ? eu.label : exec.situacao}</span>
                    <div className="lf-muted">
                      {fmtDataHora(exec.inicio)}
                      {exec.fim ? ` → ${fmtDataHora(exec.fim)}` : ""}
                      {exec.desatualizada ? " · desatualizada" : ""}
                    </div>
                    {exec.erro ? <div className="bf-text-danger" style={{ fontSize: 12 }}>{exec.erro}</div> : null}
                  </>
                ) : (
                  "—"
                )}
              </td>
              <td className="is-number">
                {exec ? (
                  <>
                    {Math.round(progressoExecucao(exec) * 100)}%
                    {exec.itensTotal ? (
                      <div className="lf-muted">
                        {fmtNumero(exec.itensFeitos)} / {fmtNumero(exec.itensTotal)}
                      </div>
                    ) : null}
                  </>
                ) : (
                  "—"
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}
